import { captureSessionEpoch, isSessionEpochCurrent } from './sessionEpoch';

/** One bounded batching window; events during a fetch cause one trailing fetch. */
export function createCoalescedRefresh(refresh: () => Promise<unknown>, delayMs = 100) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let running = false;
  let disposed = false;
  let pendingEpoch: number | undefined;
  let pendingDelay = delayMs;

  const schedule = () => {
    if (disposed || running || timer !== undefined || pendingEpoch === undefined) return;
    timer = setTimeout(() => { timer = undefined; void flush(); }, pendingDelay);
  };
  const flush = async () => {
    const epoch = pendingEpoch;
    pendingEpoch = undefined;
    pendingDelay = delayMs;
    if (disposed || epoch === undefined || !isSessionEpochCurrent(epoch)) return;
    running = true;
    try { await refresh(); }
    catch (error) { console.error('Failed to refresh state:', error); }
    finally { running = false; schedule(); }
  };
  return {
    request(immediate = false) {
      if (disposed) return;
      pendingEpoch = captureSessionEpoch();
      if (immediate) {
        pendingDelay = 0;
        if (timer !== undefined) clearTimeout(timer);
        timer = undefined;
      }
      schedule();
    },
    dispose() {
      disposed = true;
      pendingEpoch = undefined;
      if (timer !== undefined) clearTimeout(timer);
      timer = undefined;
    },
  };
}
